
import {Options, Vue} from 'vue-class-component';
import {LoginForm} from '@/components/LoginForm';
import {MainContent} from '@/components/MainContent';
import ModuleAuth from '@/store/auth';

@Options({
    name: 'App',
    components: {
        LoginForm,
        MainContent
    },
})
export default class extends Vue {
    get isAuthenticated(): boolean {
        return ModuleAuth.isAuthenticated;
    }

    async mounted() {
        await ModuleAuth.attemptLogin();
    }
}
